/**
 * 数値の項目で並べ替えた新しい配列を返す（元の配列は変えない）。
 * 値が null / undefined のもの（利益が計算できない商品など）は、高い順・低い順どちらでも最後に回す。
 */
export const sortByField = <T>(items: T[], field: keyof T, desc: boolean): T[] =>
  [...items].sort((a, b) => {
    const va = a[field] as unknown as number | null | undefined;
    const vb = b[field] as unknown as number | null | undefined;
    if (va == null && vb == null) return 0;
    if (va == null) return 1;
    if (vb == null) return -1;
    return desc ? vb - va : va - vb;
  });
